export const communityPageToastMessageSelector = state => state.communityToasts.get('communityPageToastMessage');
export const communitiesPageToastMessageSelector = state => state.communityToasts.get('communitiesPageToastMessage');
